import React, { useEffect } from 'react';
import { Box } from '@televet/kibble-ui/build/chakra';
import { Text } from '@televet/kibble-ui/build/components/Text';
import { useHistory } from 'react-router-dom';
import { RouteBasePaths } from 'routes';

const GlobalAutomationsSettings = (): JSX.Element => {
  const history = useHistory();

  useEffect(() => {
    history.push(RouteBasePaths.GlobalAutomations);
  }, [history]);

  return (
    <Box>
      <Text>Redirecting...</Text>
    </Box>
  );
};

export default GlobalAutomationsSettings;
